import { render, staticRenderFns } from "./miniQuestionAddPop.vue?vue&type=template&id=ef02f020&scoped=true"
import script from "./miniQuestionAddPop.vue?vue&type=script&lang=js"
export * from "./miniQuestionAddPop.vue?vue&type=script&lang=js"
import style0 from "./miniQuestionAddPop.vue?vue&type=style&index=0&id=ef02f020&prod&lang=less"
import style1 from "./miniQuestionAddPop.vue?vue&type=style&index=1&id=ef02f020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef02f020",
  null
  
)

export default component.exports